module.exports = __webpack_public_path__ + "static/media/ic_link.37f8f02a.svg";